module.exports = __webpack_public_path__ + "img/1483241955.5afc1098.jpg";